import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { DetalleService } from './detalle.service';
import { Mensaje } from '../../shared/models/mensaje';

@Injectable()
export class DetalleSolicitudResolver implements Resolve<Mensaje> {

  constructor(private detalleService: DetalleService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Mensaje> | Promise<Mensaje> | Mensaje {
    var autorizacion: string = 'S';
    if (route.queryParams['q'] == 'S') {
      autorizacion = 'N';
    }

    return this.detalleService.consultarDetalleSolicitud(+route.params['id'], autorizacion);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/core/services/detalle-solicitud-resolver.service.ts